import { getWxShareConfig } from '@/servers/user.js';
import wx from 'weixin-js-sdk';

export const wxShareMixins = {
  mounted() {
    this.getShareInfo();
  },

  data() {
    return {
      shareTitle: '',
      shareDesc: '',
    };
  },

  methods: {
    updateShareData() {
      let shareData = {
        title: this.shareTitle ? this.shareTitle : '中国滑雪登山',
        desc: this.shareDesc ? this.shareDesc : '',
        link: location.href.split('#')[0], // 分享后的地址
        imgUrl: 'http://skimo.chipskill.com/static/img/logo.png',
        success: function () {

        },
        error: function (err) {
          console.error(err);
        }
      };
      wx.updateAppMessageShareData(shareData);
      wx.updateTimelineShareData(shareData);
    },

    getShareInfo() {
      let that = this;
      getWxShareConfig(
        location.href.split('#')[0],
        function (config) {
          console.log(config) 
          config['jsApiList'] = [
            'updateAppMessageShareData', // 分享到朋友
            'updateTimelineShareData', // 分享到朋友圈
          ];
          wx.config(config);
          wx.ready(() => {
            that.updateShareData();
          });
        },
        function () {
          console.log('获取分享信息失败');
        },
      );
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/wx_share.js